import React from 'react';
import { useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

const PanelUsers = () => {
  const users = useSelector((state) => state.users.users);
  const status = useSelector((state) => state.users.status);
  const error = useSelector((state) => state.users.error);

  const getParentTeamName = (parentId) => {
    const parentUser = users.find(user => user.coreId === parentId);
    return parentUser ? parentUser.teamName : '';
  };

  const rawUsers = (users && Array.isArray(users) && users.length) ? users : [];

  const sortedUsers = rawUsers ? [...rawUsers].sort((a, b) => a.name.localeCompare(b.name)) : [];
  const filledUsers = sortedUsers.map(user => {
    let teamName = getParentTeamName(user.parent);
    let leaderName = user.teamName && `Leader: ${user.teamName}`;
    return { ...user, teamName, leaderName };
  });

  const tableBody = (<TableBody>
    {filledUsers.map((user) => (
      <TableRow key={user.coreId}>
        <TableCell>{user.name}</TableCell>
        <TableCell>{user.email}</TableCell>
        <TableCell>{user.coreId}</TableCell>
        <TableCell>{user.parent}</TableCell>
        <TableCell>
          Team: {user.teamName}<br/>
          {user.leaderName}
        </TableCell>
      </TableRow>
    ))}
  </TableBody>);

  return (
    <div>
      <Typography variant="h4">Users</Typography>
      {status === 'loading' && <Typography>Loading...</Typography>}
      {status === 'failed' && <Typography color="error">{error}</Typography>}
      {(status === 'succeeded' || status === 'idle') && rawUsers && (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Core ID</TableCell>
                <TableCell>Parent</TableCell>
                <TableCell>Team Name</TableCell>
              </TableRow>
            </TableHead>
            {tableBody}
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default PanelUsers;
